<template>
  <EgateField v-model="context.value.value[props.field.key]" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import EgateField from '@/apps/brelag/mandator-user/components/editor/egate/EgateField.vue'

import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
